module.exports = __webpack_public_path__ + "static/media/grid6.da2ddea8.jpg";